import Vue from 'vue'
import Vuex from 'vuex'
import userStore from './modules/userStore'
import menuStore from './modules/menuStore'
import pushStore from './modules/pushStore'
import clientStore from './modules/clientStore'
import testStore from './modules/testStore'
import vocStore from './modules/vocStore'
import noticeStore from './modules/noticeStore'
import fontStore from './modules/fontStore'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
const ls = new SecureLS({ isCompression: false })
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentPath: '',
    dialogIsOpen: false,
    searchWord: '',
    date: new Date().toISOString().substring(0, 7),
    isBack: false,
    index: 0,
    isRefresh: false,
    isOpenErrorDialog: false
  },
  getters: {
    getCurrentPath: state => state.currentPath,
    getDialogIsOpen: state => state.dialogIsOpen,
    getSearchWord: state => state.searchWord,
    getDate: state => state.date,
    getIsBack: state => state.isBack,
    getIndex: state => state.index,
    getIsRefresh: state => state.isRefresh,
    getIsOpenErrorDialog: state => state.isOpenErrorDialog
  },
  mutations: {
    mutationCurrentPath: (state, payload) => {
      state.currentPath = payload
    },

    mutationDialogIsOpen: (state, payload) => {
      state.dialogIsOpen = payload
    },

    mutationDate: (state, payload) => {
      state.date = payload
    },

    mutationSearchWord: (state, payload) => {
      state.searchWord = payload
    },

    mutationIsBack: (state, payload) => {
      state.isBack = payload
    },

    mutationIndex: (state, payload) => {
      state.index += payload
    },

    mutationIsRefresh: (state, payload) => {
      state.isRefresh = payload
    },

    mutationIsOpenErrorDialog: (state, payload) => {
      state.isOpenErrorDialog = payload
    }
  },
  actions: {
    actionCurrentPath: ({ commit }, payload) => {
      commit('mutationCurrentPath', payload)
    }

  },
  modules: {
    userStore: userStore,
    menuStore: menuStore,
    pushStore: pushStore,
    clientStore: clientStore,
    testStore: testStore,
    noticeStore: noticeStore,
    vocStore: vocStore,
    fontStore: fontStore
  },
  plugins: [
    createPersistedState({
      paths: ['userStore', 'pushStore', 'menuStore', 'clientStore', 'testStore', 'noticeStore', 'vocStore', 'fontStore'],
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key)
      }
    })
  ]
})
